var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.computedTag,_vm._b({tag:"component",style:(_vm.computedTextStyles),domProps:{"innerHTML":_vm._s(_vm.computedHtml)}},'component',{ id: _vm.id },false))}
var staticRenderFns = []

export { render, staticRenderFns }